import { Piece, PieceDocPage } from '@apiContract';

const mapPageToThumbnail = (page: PieceDocPage) => {
  return {
    id: page.id,
    image: page.originalUrl,
    order: page.sortOrder,
    croppedImage: page.croppedUrl || '',
    thumbnailImage: page.thumbnailUrl || '',
  };
};

export const getInitialThumbnails = (piece: Piece | null | undefined) => {
  if (!piece || !piece.pieceDoc) return [];
  const piecePages = piece.pieceDoc.piecePages;
  if (!piecePages.length) return [];
  const thumbnails = piecePages.map((page) => mapPageToThumbnail(page));
  const sortedThumbnails = thumbnails.sort((a, b) => a.order - b.order);
  return sortedThumbnails;
};
